<template>
  <section id="portfolio" class="portfolio section-bg">
    <div class="container" data-aos="fade-up">

      <div class="section-title">
        <h2>Portafolio</h2>
      </div>

      <div class="row">
        <div class="col-lg-12 d-flex justify-content-center" data-aos="fade-up" data-aos-delay="100">
          <ul id="portfolio-flters">
            <li data-filter="*" class="filter-active">Todos</li>
            <li data-filter=".filter-prianti">Prianti</li>
            <li data-filter=".filter-freelance">Freelance</li>
          </ul>
        </div>
      </div>

      <div class="row portfolio-container" data-aos="fade-up" data-aos-delay="200">
        <div class="col-lg-4 col-md-6 portfolio-item filter-prianti">
          <div class="portfolio-wrap">
            <img src="assets/img/portfolio/portfolio-1.jpg" class="img-fluid" alt="">
            <div class="portfolio-info">
              <h4>Bulkmatic</h4>
              <p>Pagina informática</p>
              <br>
              <p>CUENTA CON SECCIÓN DE NOTICIAS, COMENTARIOS, GALERÍA, UBICACIONES, REALIZADO CON WordPress. </p>
              <div class="portfolio-links">
                <a href="http://www.bulkmatic.com.mx/wwwbulkmat" style="font-size: 18px" class="mt-1" target="_blank">VER MÁS...</a>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-6 portfolio-item filter-freelance">
          <div class="portfolio-wrap" style="border-radius: 3%; box-shadow: 6px 6px 6px 1px rgba(0, 0, 0, 0.2)">
            <img src="assets/img/portfolio/portfolio-2.jpg" class="img-fluid" alt="">
            <div class="portfolio-info">
              <h4>Animal Karma</h4>
              <p>OCR, RDE</p><br>
              <p>SISTEMA CON RECONOCIMIENTO DE IMÁGENES O VIDEOS, PARA CLASIFICAR ANIMALES CAPTURADOS EN CÁMARAS.</p>
              <div class="portfolio-links">
                <a href="https://www.animalkarma.org.mx" style="font-size: 18px" class="mt-1" target="_blank">VER MÁS...</a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 portfolio-item filter-prianti">
          <div class="portfolio-wrap sombra">
            <img src="assets/img/portfolio/portfolio-3.jpg" class="img-fluid" alt="">
            <div class="portfolio-info">
              <h4>Stewart</h4>
              <p>ALGORITMO PARA OBTENER HORARIOS</p> <br>
              <p>LECTURA DE XLS OBTENIENDO LAS HORAS TRABAJADAS Y CALCULANDO EL PAGO MENSUAL</p>
              <div class="portfolio-links">
                <a href="https://prianti.mx/test/stewart" style="font-size: 18px" class="mt-1" target="_blank">VER MÁS...</a>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-6 portfolio-item filter-freelance">
          <div class="portfolio-wrap sombra">
            <img src="assets/img/portfolio/portfolio-5.jpg" class="img-fluid" alt="">
            <div class="portfolio-info">
              <h4>Farmazonmx</h4>
              <p>Ecomerce</p>
              <br>
              <p>Sistema para la venta de medicinas, por menudeo y mayoreo.</p>
              <div class="portfolio-links">
                <a href="http://farmazonmx.com" style="font-size: 18px" class="mt-1" target="_blank">VER MÁS...</a>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-6 portfolio-item filter-prianti">
          <div class="portfolio-wrap sombra">
            <img src="assets/img/portfolio/portfolio-6.jpg" class="img-fluid" alt="">
            <div class="portfolio-info">
              <h4>SiEnvio</h4>
              <p>Delivery App</p>
              <br>
              <p>WebApp de compra y venta de comida, Vuejs, Laravel</p>
              <div class="portfolio-links">
                <a href="https://www.sienvio.mx" style="font-size: 18px" class="mt-1" target="_blank">VER MÁS...</a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 portfolio-item filter-prianti">
          <div class="portfolio-wrap sombra">
            <img src="assets/img/portfolio/portfolio-9.jpg" class="img-fluid" alt="">
            <div class="portfolio-info">
              <h4>Inzu seguros</h4>
              <p>Sistema de seguros</p>
              <br>
              <p>
                Cotizaciones de seguros, emicion de seguros y polizas, pagos en stripe.
              </p>
              <div class="portfolio-links">
                <a href="https://inzu.mx" style="font-size: 18px" class="mt-1" target="_blank">VER MÁS...</a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 portfolio-item filter-freelance">
          <div class="portfolio-wrap sombra">
            <img src="assets/img/portfolio/Eticket.png" class="img-fluid" alt="">
            <div class="portfolio-info">
              <h4>ETICKET</h4>
              <p>Servicio creado para la gestion de tickets electronicos, area del proyecto  paperless. </p>
              <br>
              <div class="portfolio-links">
                <a href="https://github.com/DRFLASH1312/banco" style="font-size: 18px" class="mt-1" target="_blank">GITHUB</a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 portfolio-item filter-freelance">
          <div class="portfolio-wrap sombra">
            <img src="assets/img/portfolio/MORELOS.png" class="img-fluid" alt="">
            <div class="portfolio-info">
              <h4>VOZ TRASNPARENTE</h4>
              <p>Replica de COMISIÓN ESTATAL DE GARANTÍA DE
                ACCESO A LA INFORMACIÓN PUBLICA construyendo la api. </p>
              <br>
              <div class="portfolio-links">
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 portfolio-item filter-freelance">
          <div class="portfolio-wrap sombra">
            <img src="assets/img/portfolio/cobranzaaguascalientes.png" class="img-fluid" alt="">
            <div class="portfolio-info">
              <h4>Cobranza Aguascalientes</h4>
              <p>Sistema que permite realizar prestamos y cobranzas a los habitantes de aguascalientes, realizado en Vuejs y laravel 8. </p>
              <br>
              <div class="portfolio-links">
                <a href="https://cobranza.aguascalientesdigital.com.mx/" style="font-size: 18px" class="mt-1" target="_blank">Ver más...</a>
              </div>
            </div>
          </div>
        </div>


        <!--

        <div class="col-lg-4 col-md-6 portfolio-item filter-card">
          <div class="portfolio-wrap">
            <img src="assets/img/portfolio/portfolio-4.jpg" class="img-fluid" alt="">
            <div class="portfolio-info">
              <h4>Diseño de aplicación</h4>
              <p>DISEÑADO EN FIGMA</p> <br>
              <p>APLICACIÓN DE DELIVERY (PROTOTIPO)</p>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-6 portfolio-item filter-card">
          <div class="portfolio-wrap">
            <img src="assets/img/portfolio/portfolio-7.jpg" class="img-fluid" alt="">
            <div class="portfolio-info">
              <h4>Diseño delivery App</h4>
              <p>Diseño</p>
              <br>
              <p>
                Diseño realizado en Adobe XD, sistema de alta y venta de comida
              </p>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-6 portfolio-item filter-card">
          <div class="portfolio-wrap">
            <img src="assets/img/portfolio/portfolio-8.jpg" class="img-fluid" alt="">
            <div class="portfolio-info">
              <h4>Catálogo de recetas</h4>
              <p>Publicidad</p>
              <br>
              <p>
                Diseño realizado en Figma, recetas de Otoño.
              </p>
            </div>
          </div>
        </div>
        -->

      </div>

    </div>
  </section>

</template>

<script>
import Jobs from "@/utils";

export default {
name: "PortafolioComponent",
  data:()=>({
    portfolio:Jobs
  })
}
</script>

<style scoped>
  .sombra{
    border-radius: 3%; box-shadow: 6px 6px 6px 1px rgba(0, 0, 0, 0.2)
  }
</style>